import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Button, Accordion, Icon, Table } from 'semantic-ui-react';
import { LoadingBar, TableForm, Pagination } from 'components/Commons';
import styled from 'styled-components';
import cm from 'helpers/commons';

class BillDetModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  pageClick = (page) => {
    const { billDetListSel, detail } = this.props;
    const params = {
      page: page,
      pageRow: 15
    };
    billDetListSel(detail.invoiceIdx, params); // 식대 상세 조회
  };

  render() {
    const { modalFn, billDetList, billDetTotal, detail } = this.props;
    const { open, close } = modalFn;
    const unit = cm.unit();
    const tabledata = {
      header: {
        main: [
          { data: '결제번호', textAlign: 'left' },
          { data: '날짜', textAlign: 'left' },
          { data: 'ID', textAlign: 'left' },
          { data: '이름', textAlign: 'left' },
          { data: '제휴식당', textAlign: 'left' },
          { data: '회사식대', textAlign: 'right' },
          { data: '회사 정산금액', textAlign: 'right' },
          { data: '결제형태', textAlign: 'left' }
        ]
      },
      body: {
        message: '-',
        main: null
      }
    };
    const total = {
      price: 0,
      sales: 0,
      title: ''
    };
    const pagings = {
      page: 1,
      pagerow: 15,
      totalcount: 0
    };

    if (billDetTotal && billDetTotal.data) {
      const { totalPrice, totalSales, totalCount } = billDetTotal.data;
      let billingAccountName = null;
      let MMdd = null;
      if (detail) {
        const invoiced = detail.date.invoiced;
        const invoiceYmd = cm.yyyyMMdd(invoiced);
        billingAccountName = detail.billingAccountName;
        MMdd = `${invoiceYmd.substring(5, 7)}월 ${invoiceYmd.substring(8, 10)}일`;
      }
      total.price = cm.numberComma(totalPrice);
      total.sales = cm.numberComma(totalSales);
      total.title = `${billingAccountName} ${MMdd}`;
      pagings.totalcount = totalCount;
    }

    if (billDetList && billDetList.data) {
      const { usagehistory, paging } = billDetList.data;
      pagings.page = paging.page;
      pagings.pagerow = paging.pagerow;
      const headerTemp = cm.tableHeaderList(tabledata.header.main, 4, null, 'default');
      // 테이블 항목
      tabledata.header.main = headerTemp;
      // 테이블 리스트
      tabledata.body.main = usagehistory.map((item) => {
        const { user, store, point, pay } = item;
        let obj = {
          row: [
            { data: item.id, textAlign: 'left' },
            {
              data: `${cm.yyyyMMdd(new Date(item.usedate))} ${cm.hhmmss(new Date(item.usedate))}`,
              textAlign: 'left'
            },
            { data: user.signid, textAlign: 'left' },
            { data: user.name, textAlign: 'left' },
            { data: store.name, textAlign: 'left' },
            { data: cm.numberComma(point.com), textAlign: 'right' },
            { data: cm.numberComma(pay.amount), textAlign: 'right' },
            { data: pay.text, textAlign: 'left' }
          ]
        };
        obj = cm.defalutTableStaffDivisionSet(obj.row, 4, user.orgCode);
        return obj;
      });
    } else {
    }
    return (
      <Modal className="modal-large" open={open} onClose={close}>
        <Modal.Header>식대 상세내역</Modal.Header>
        <StyledModalContent>
          {billDetTotal && billDetTotal.data ? (
            billDetList && billDetList.data ? (
              <div>
                <Table celled>
                  <Table.Body>
                    <Table.Row>
                      <StyleTitleCell>청구서</StyleTitleCell>
                      <Table.Cell style={{ width: 416 }}>{total.title}</Table.Cell>
                      <StyleTitleCell>회사식대 총액</StyleTitleCell>
                      <Table.Cell style={{ width: 416 }}>
                        {unit === '원' ? `${total.sales}원` : `${total.sales}장(${total.price}원)`}
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
                <div className="table-box" style={{ marginTop: 24 }}>
                  <TableForm tabledata={tabledata} />
                </div>
                <div className="table-paging">
                  <Pagination
                    page={pagings.page}
                    pageRow={pagings.pagerow}
                    pageBlock={10}
                    totalCount={pagings.totalcount}
                    pageClick={this.pageClick}
                  />
                </div>
              </div>
            ) : (
              <LoadingBar />
            )
          ) : (
            <LoadingBar />
          )}
        </StyledModalContent>
        <Modal.Actions>
          <Button positive onClick={close} content="닫기" />
        </Modal.Actions>
      </Modal>
    );
  }
}

const StyledModalContent = styled(Modal.Content)`
  &&&& {
    /* overflow: auto; */
  }
`;

const StyleTitleCell = styled(Table.Cell)`
  &&&& {
    width: 160px;
    font-weight: bold;
  }
`;

BillDetModal = connect((state) => ({
  billDetList: state.usage.billDetList,
  billDetTotal: state.usage.billDetTotal
}))(BillDetModal);

export default BillDetModal;
